<div class="dm-page-content mb-25">
    <div class="container-fluid">

        <app-search-bar (onPrimaryBtnClick)="ShowAddUser()" primaryBtnLabel="Novo Utilizador" [showFilterBtn]="true"
            (onFilterBtnClick)="showModalFilter()"></app-search-bar>

        <div class="row">
            <ng-container *ngIf="pagination?.data?.length; else noCursos">
                <app-table [pagination]="pagination" [columns]="columns" [actions]="actions"
                    (pageChange)="onPageChange($event)"></app-table>
            </ng-container>
            <ng-template #noCursos>
                <div class="no-data">
                    <app-data-void titulo="Nenhum utilizador encontrado"
                        descricao="Tente novamente mais tarde."></app-data-void>
                </div>
            </ng-template>
        </div>
    </div>
</div>

<p-dialog header="Asociar utilizador" [modal]="true" [(visible)]="showModalAssociate" [style]="{ width: '35rem' }">
    <form [formGroup]="associateForm" class="p-fluid grid">
        <div class="field d-flex flex-column col-12">
            <label for="username">utilizador</label>
            <p-select [filter]="true" id="username" appendTo="body" formControlName="username"
                [options]="[selectedUser]" optionLabel="nome" optionValue="username" placeholder="Usuário"
                class="w-full" [disabled]="true">
            </p-select>

        </div>
        <div class="field d-flex flex-column col-12">
            <label for="groupId">Grupo</label>
            <p-select [filter]="true" id="groupId" placeholder="Seleccione o grupo" appendTo="body"
                formControlName="groupId" class="w-full" [options]="listGrupos" optionLabel="nomeGrupo"
                optionValue="id" />
            <div *ngIf="associateForm.get('groupId')?.invalid && associateForm.get('groupId')?.touched"
                class="error-message">
                Grupo é obrigatório
            </div>
        </div>
    </form>
    <div class="d-flex justify-content-between">
        <p-button label="Cancelar" severity="secondary" (click)="cancel()" />
        <p-button label="Associar" (click)="saveUser()" />
    </div>
</p-dialog>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<p-toast></p-toast>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

    <form [formGroup]="form" class="p-fluid grid">
        <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
            <label>{{ filter.placeholder }}</label>

            <!-- Se for dropdown -->
            <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
                [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
                [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
            </p-select>

            <!-- Se for texto -->
            <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
                [placeholder]="filter.placeholder" class="w-full" />
        </div>
    </form>


    <div class="flex items-center justify-content-between">
        <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
        <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
    </div>
</p-dialog>

<p-dialog header="Desassociar utilizador" [modal]="true" [(visible)]="showDesassociateModal"
    [style]="{ width: '35rem' }">
    <form [formGroup]="dissassociateForm" class="p-fluid grid">
        <div class="field d-flex flex-column col-12">
            <label for="username">utilizador</label>
            <p-select [filter]="true" id="username" appendTo="body" formControlName="username"
                [options]="[selectedUser]" optionLabel="nome" optionValue="username" placeholder="Usuário"
                class="w-full" [disabled]="true">
            </p-select>

        </div>
        <div class="roles-list mb-4 col-12 w-100">
            <ng-container *ngIf="listGroupsByUser.length; else noGroups">
                <div class="p-fluid grid roles-items w-100">
                    <div *ngFor="let group of listGroupsByUser; trackBy: trackByGroup" class="field col-12 w-100">
                        <div class="d-flex align-items-center justify-content-between mb-2 w-100">
                            <span>{{ group.nomeGrupo }}</span>
                            <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text"
                                (click)="RemoveUserFromGroup(selectedUser?.username || '', group.id, group.nomeGrupo)"
                                pTooltip="Remover do grupo" tooltipPosition="top">
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #noGroups>
                <p class="mt-3 text-muted">Usuário não pertence a nenhum grupo.</p>
            </ng-template>
        </div>

        <p-confirmDialog></p-confirmDialog>

    </form>
    <div class="d-flex justify-content-between">
        <p-button label="Cancelar" severity="secondary" (click)="showDesassociateModal = false" />
        <p-button label="Fechar" (click)="showDesassociateModal = false" />
    </div>
</p-dialog>

<p-dialog header="Novo Utilizador" [modal]="true" [(visible)]="ShowNewUser" [style]="{ width: '42rem' }"
    appendTo="body">

    <form [formGroup]="formNewUser" class="p-fluid grid">

        <div class="field col-12">
            <label for="numeroBI">Número Bilhete de Identidade*</label>
            <div class="flex align-items-center relative">
                <input id="numeroBI" type="search" class="w-full" pInputText formControlName="numeroBI"
                    placeholder="Informe o número do BI" />
                <button pButton type="button" icon="pi pi-search" class="search-btn"
                    [disabled]="formNewUser.get('numeroBI')?.invalid" (click)="searchDocumentNumber()"
                    aria-label="Search"></button>
            </div>
            <div *ngIf="formNewUser.get('numeroBI')?.touched && formNewUser.get('numeroBI')?.invalid">
                <small class="error-message" *ngIf="formNewUser.get('numeroBI')?.errors?.['required']">Número
                    Bilhete de Identidade é obrigatório.</small>
            </div>
        </div>

        <div class="field col-12" *ngIf="userName">
            <strong>NOME:</strong> {{userName}}
        </div>

        <div class="field col-12">
            <label for="email">Email*</label>
            <input id="email" type="email" class="w-full" pInputText formControlName="email"
                placeholder="Informe o seu email" />
        </div>

        <div class="field col-12">
            <label for="groupId">Grupo de Permissões*</label>
            <p-select id="groupId" formControlName="groupId" [options]="listGrupos" optionLabel="nomeGrupo"
                optionValue="id" placeholder="Seleccione o grupo de permissões" class="w-full" [filter]="true"
                appendTo="body">
            </p-select>

            <small class="text-muted">
                Este grupo define as permissões que o utilizador terá no sistema.
            </small>

            <div *ngIf="formNewUser.get('groupId')?.touched && formNewUser.get('groupId')?.invalid">
                <small class="error-message">Grupo é obrigatório.</small>
            </div>
        </div>


        <div class="field col-6">
            <label for="senha">Palavra-Passe*</label>
            <p-password [toggleMask]="true" id="senha" class="campoSenha" formControlName="senha"
                placeholder="Informe a palavra-passe" [feedback]="false" />
            <div *ngIf="formNewUser.get('password')?.touched && formNewUser.get('password')?.invalid"
                class="invalid-feedback">
                <span *ngIf="formNewUser.get('senha')?.hasError('required')">Este campo é obrigatório.</span>
                <span *ngIf="formNewUser.get('senha')?.hasError('minlength')">A senha deve ter no mínimo 8
                    caracteres.</span>
                <span *ngIf="formNewUser.get('senha')?.hasError('maxlength')">A senha deve ter no máximo 16
                    caracteres.</span>
            </div>
        </div>

        <div class="field col-6">
            <label for="senhaConfirm">Confirmar palavra-passe*</label>
            <p-password [toggleMask]="true" id="senhaConfirm" class="campoSenha" formControlName="senhaConfirm"
                placeholder="Informe a palavra-passe" [feedback]="false" />
            <div *ngIf="formNewUser.get('confirmPassword')?.touched && formNewUser.get('confirmPassword')?.invalid"
                class="invalid-feedback">
                <span *ngIf="formNewUser.get('senhaConfirm')?.hasError('required')">Este campo é obrigatório.</span>
                <span *ngIf="formNewUser.get('senhaConfirm')?.hasError('passwordMismatch')">As senhas não
                    coincidem.</span>
            </div>
        </div>

    </form>

    <div class="flex items-center justify-content-between">
        <p-button label="Cancelar" severity="secondary" (click)="ShowNewUser = false" />
        <p-button label="Criar Utilizador" [disabled]="formNewUser.invalid" (click)="createUser()" />
    </div>
</p-dialog>

<p-dialog header="Redefinir Senha" [modal]="true" [(visible)]="ShowRecoveryPassword" [style]="{ width: '42rem' }"
    appendTo="body">

    <form [formGroup]="formRecoveryPassword" class="p-fluid grid">

        <div class="field col-12">
            <label for="Username">Username</label>
            <input id="Username" type="Username" class="w-full" pInputText formControlName="Username" />
        </div>

        <div class="field col-12" *ngIf="userName">
            <strong>NOME:</strong> {{userName}}
        </div>

        <div class="field col-12">
            <label for="email">Email</label>
            <input id="email" type="email" class="w-full" pInputText formControlName="email" />
        </div>

        <div class="field col-6">
            <label for="novasenha">Palavra-Passe*</label>
            <p-password [toggleMask]="true" id="novasenha" class="campoSenha" formControlName="novasenha"
                placeholder="Informe a nova palavra-passe" [feedback]="false" />
            <div *ngIf="formNewUser.get('password')?.touched && formNewUser.get('password')?.invalid"
                class="invalid-feedback">
                <span *ngIf="formNewUser.get('novasenha')?.hasError('required')">Este campo é obrigatório.</span>
                <span *ngIf="formNewUser.get('novasenha')?.hasError('minlength')">A senha deve ter no mínimo 8
                    caracteres.</span>
                <span *ngIf="formNewUser.get('novasenha')?.hasError('maxlength')">A senha deve ter no máximo 16
                    caracteres.</span>
            </div>
        </div>

        <div class="field col-6">
            <label for="novasenhaConfirm">Confirmar nova palavra-passe*</label>
            <p-password [toggleMask]="true" id="novasenhaConfirm" class="campoSenha" formControlName="novasenhaConfirm"
                placeholder="Confirme a nova palavra-passe" [feedback]="false" />
            <div *ngIf="formNewUser.get('novasenhaConfirm')?.touched && formNewUser.get('novasenhaConfirm')?.invalid"
                class="invalid-feedback">
                <span *ngIf="formNewUser.get('novasenhaConfirm')?.hasError('required')">Este campo é obrigatório.</span>
                <span *ngIf="formNewUser.get('novasenhaConfirm')?.hasError('passwordMismatch')">As senhas não
                    coincidem.</span>
            </div>
        </div>
    </form>

    <div class="flex items-center justify-content-between">
        <p-button label="Cancelar" severity="secondary" (click)="ShowRecoveryPassword = false" />
        <p-button label="Redefinir senha" [disabled]="formRecoveryPassword.invalid" (click)="recoveryPassword()" />
    </div>
</p-dialog>